import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { PWAInstallProvider } from "./context/PWAInstallContext";
import { OnlineStatusProvider } from "./context/OnlineStatusContext";
import AnnouncementBar from "./components/feature/AnnouncementBar";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import MobileBottomNav from "./components/feature/MobileBottomNav";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import PWAInstallBanner from "./components/feature/PWAInstallBanner";
import OnlineStatusToast from "./components/feature/OnlineStatusToast";
import BackToTop from "./components/feature/BackToTop";
import ScrollProgressBar from "./components/feature/ScrollProgressBar";
import ScrollToTop from "./components/base/ScrollToTop";
import SmoothScroll from "./components/base/SmoothScroll";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <OnlineStatusProvider>
          <PWAInstallProvider>
            <WishlistProvider>
              <CartProvider>
                <ScrollToTop />
                <SmoothScroll />
                <ScrollProgressBar />
                <AnnouncementBar />
                <Navbar />
                <main className="page-with-bottom-nav">
                  <AppRoutes />
                </main>
                <Footer />
                <MobileBottomNav />
                <FloatingWhatsApp />
                <BackToTop />
                <PWAInstallBanner />
                <OnlineStatusToast />
              </CartProvider>
            </WishlistProvider>
          </PWAInstallProvider>
        </OnlineStatusProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;